import { Card } from '@populix/pop-ui'
import { useRouter } from 'next/navigation'

import { TLinkedPartner } from '@/libs/types/global.types'

type TConnectedPartners = {
  data: TLinkedPartner[]
}

export default function ConnectedPartners({ data }: Readonly<TConnectedPartners>) {
  const { push } = useRouter()

  if (data && data?.length === 0) {
    return null
  }

  return (
    <Card noElevation>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col gap-1'>
          <h2 className='text-base font-semibold'>Connected Partners</h2>
          <p className='text-xs font-normal'>
            Each connected partners have their own reward balance.
          </p>
        </div>
        <hr />
        {data?.length > 0 &&
          data.map((value) => (
            <div className='flex flex-col gap-4' key={value?.partnerId}>
              <h3 className='text-xs font-semibold'>{value?.partnerName}</h3>
              <div className='flex flex-row items-start justify-between gap-4'>
                <p className='sentry-mask break-all text-xs font-normal text-pop-grey-500'>
                  {value?.deepLink ? 'Linked' : `Open ${value?.partnerName} to access your account`}
                </p>
                {value?.deepLink && (
                  <button
                    className={`cursor-pointer text-right text-xs font-normal text-pop-blue-400`}
                    onClick={() => push(value?.deepLink)}
                    type='button'
                  >
                    Open {value?.partnerName}
                  </button>
                )}
              </div>
            </div>
          ))}
      </div>
    </Card>
  )
}
